<template>
  <legend v-if="title" class="formLegend">{{ title }}</legend>
</template>

<script>
export default {
  name: 'FormLegend',
  props: {
    title: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
.formLegend {
  max-width: 90%;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 115.5%;
  color: $dark-800;
}
</style>
